import { allCountries } from 'country-region-data'

export const countryOptions = allCountries.map((country, index) => ({
	label: country[0],
	value: country[1],
	id: index,
}))

export const stateOptions: { label: string; value: string }[] = [
	{ value: 'ACT', label: 'Australian Capital Territory (ACT)' },
	{ value: 'NSW', label: 'New South Wales (NSW)' },
	{ value: 'NT', label: 'Northern Territory (NT)' },
	{ value: 'QLD', label: 'Queensland (QLD)' },
	{ value: 'SA', label: 'South Australia (SA)' },
	{ value: 'TAS', label: 'Tasmania (TAS)' },
	{ value: 'VIC', label: 'Victoria (VIC)' },
	{ value: 'WA', label: 'Western Australia (WA)' },
]
